import { render, staticRenderFns } from "./ScmCollectLog.vue?vue&type=template&id=3efedc96&scoped=true"
import script from "./ScmCollectLog.vue?vue&type=script&lang=js"
export * from "./ScmCollectLog.vue?vue&type=script&lang=js"
import style0 from "./ScmCollectLog.vue?vue&type=style&index=0&id=3efedc96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efedc96",
  null
  
)

export default component.exports